import { TaskTypeEnum } from '@api';

export const taskTypeOptions = [
  { label: 'Tabular ML', value: TaskTypeEnum.tabularMl },
  { label: 'Single-turn Chat', value: TaskTypeEnum.singleTurnChat },
  { label: 'Text Generation', value: TaskTypeEnum.textGeneration },
  { label: 'Information Extraction', value: TaskTypeEnum.informationExtraction },
  { label: 'Conversational Agent', value: TaskTypeEnum.conversationalAgent },
  { label: 'Voice Agent', value: TaskTypeEnum.voiceAgent },
  { label: 'Concierge', value: TaskTypeEnum.concierge },
];

export const taskTypeLabelMap: Record<TaskTypeEnum, string> = {
  tabular_ml: 'Tabular ML',
  single_turn_chat: 'Single-turn Chat',
  text_generation: 'Text Generation',
  information_extraction: 'Information Extraction',
  conversational_agent: 'Conversational Agent',
  voice_agent: 'Voice Agent',
  concierge: 'Concierge',
};
